import React from 'react';
import { Box, Toolbar } from '@mui/material';

interface Props {
  children: React.ReactNode;
  pr?: number;
  pl?: number;
  mb?: number;
  pb?: number;
}

const RightColumns = ({ children, pr, pl, mb, pb }: Props) => {
  return (
    <Box sx={{ marginBottom: mb ?? 10, pb: pb ?? 1 }}>
      <Toolbar />
      <Box sx={{ pt: 2, pl: pl ?? 1.5, pr: pr ?? 1.2 }}>{children}</Box>
    </Box>
  );
};

export default RightColumns;
